import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';
import ButtonIconGhostLarge from '../../common/ButtonIconGhost/ButtonIconGhostLarge';
import { Icon } from '../../icon/icon';
import { Trans, useTranslation } from 'react-i18next';
import ButtonTertiaryLarge from '../../common/ButtonTertiary/ButtonTertiaryLarge';
import ROUTER from '../../../routers/Routers';
import { Popover, Divider, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../../../store/actions/product.action';
import DropdownComponent from '../../common/DropdownComponent/DropdownComponent';
import i18next from 'i18next';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import SearchComponent from '../../common/SearchComponent/SearchComponent';
import Tag from '../../common/Tag/Tag';
import { cn } from '../../../utils/string/cn.utils';
import {
  reloadOrders,
  resetOrdersData,
} from '../../../store/reducers/room.reducer';
import {
  logout,
  requestDeleteAccount,
} from '../../../store/actions/auth.action';
import { openModal } from '../../common/Modal/openModal';
import { Avatar } from 'antd';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { Badge } from 'antd';
import { fetchCart } from '../../../store/actions/room.action';
import ButtonIconGhostSmall from '../../common/ButtonIconGhost/ButtonIconGhostSmall';
import ButtonSecondaryLarge from '../../common/ButtonSecondary/ButtonSecondaryLarge';
import { openDrawer } from '../../common/Drawer/openDrawer';
import useModalAuth from '../../auth/AuthModal';
import ButtonIconOutlineMedium from '../../common/ButtonIconOutline/ButtonIconOutlineMedium';
import { useParams } from 'react-router-dom';
import useDrawerCard from '../../../pages/CartPage/components/DrawerCart/DrawerCart';
import { useDeviceType } from '../../../hooks/useDeviceType';
import { fetchSaleProducts } from '../../../store/actions/sale-product.action';
import ProductCard from '../../homepage/ProductCard/ProductCard';
import Empty from '../../common/Empty/Empty';
import { CONST } from '../../../constants/constant';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const HeaderContext = createContext();

const Header = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const device = useDeviceType();
  const { openLogin } = useModalAuth();

  const [openBottomAccount, setOpenBottomAccount] = useState(false);
  const { openDrawerMenu } = useDrawerMenu();
  const { openDrawerSearch } = useDrawerSearch();
  const { openDrawerCart } = useDrawerCard();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { cart } = useSelector(state => state.room);
  const auth = useSelector(state => state.auth);
  const { products } = useSelector(state => state.product);

  useEffect(() => {
    if (products.isNeedReloadData) dispatch(fetchProducts());
  }, [products.isNeedReloadData, dispatch]);

  useEffect(() => {
    if (cart.isNeedReloadData && auth.accessToken) {
      dispatch(fetchCart({ countryCode: country_code }));
    }
  }, [cart.isNeedReloadData, auth.accessToken, dispatch]);

  const items = [
    {
      key: 'vi',
      show: (
        <div className="flex items-center py-4 px-8" style={{ gap: '8px' }}>
          <span className="text-label-medium">{t('Vietnamese')}</span>
        </div>
      ),
      label: (
        <div className="flex items-center py-4 px-8" style={{ gap: '8px' }}>
          <img src="/assets/icons/VI.svg" />
          <span className="text-label-medium">{t('Vietnamese')}</span>
        </div>
      ),
      onClick: () => {
        i18next.changeLanguage('vi');
      },
    },
    {
      key: 'en',
      show: (
        <div className="flex items-center py-4 px-8" style={{ gap: '8px' }}>
          <span className="text-label-medium">{t('English')}</span>
        </div>
      ),
      label: (
        <div className="flex items-center py-4 px-8" style={{ gap: '8px' }}>
          <img src="/assets/icons/US.svg" />
          <span className="text-label-medium">{t('English')}</span>
        </div>
      ),
      onClick: () => {
        i18next.changeLanguage('en');
      },
    },
  ];

  const popoverOptions = [
    {
      key: ROUTER.ACCOUNT + '/' + auth.user?.id,
      label: 'Account information',
      icon: <Icon.ICUser />,
    },
    {
      key: ROUTER.ACCOUNT + ROUTER.ORDER,
      label: 'My orders',
      icon: <Icon.ICOrder />,
      onClick: () => {
        dispatch(resetOrdersData());
        dispatch(reloadOrders());
      },
    },
    {
      key: ROUTER.ACCOUNT + ROUTER.PROJECTS,
      label: 'Design collection',
      icon: <Icon.ICModule />,
    },
    {
      key: ROUTER.ACCOUNT + ROUTER.ROOMS,
      label: 'Room collection',
      icon: <Icon.ICBedRoom />,
    },
  ];

  const renderActionHeader = (id, className) => {
    return (
      <div
        id={id}
        className={cn(
          'flex items-center gap-[16px] transition-all duration-100 ease-linear overflow-hidden w-[500px]',
          className
        )}
      >
        <ButtonTertiaryLarge
          title={t('Menu')}
          posIcon={<Icon.ICMenu />}
          type="button"
          className="text-black/80"
          onClick={() => openDrawerMenu()}
        />

        <ButtonTertiaryLarge
          title={t('Search')}
          posIcon={<Icon.ICSearch />}
          type="button"
          className="text-black/80"
          onClick={() => openDrawerSearch()}
        />

        <Popover
          classNames={{ body: '!p-0' }}
          getPopupContainer={() => document.body}
          trigger={'click'}
          content={
            <div className="flex w-[fit-content] p-[8px] rounded-[8px] bg-fills-white shadow-custom">
              <ul className="flex flex-col items-start gap-[4px] self-stretch grow">
                {products.data
                  ?.filter(item => item.has_design)
                  ?.map((item, index) => {
                    return (
                      item.type_design && (
                        <li key={index} className="grow self-stretch">
                          <ButtonTertiaryLarge
                            title={
                              <span className="text-label-large">
                                {getValueFromString(item.name)}
                              </span>
                            }
                            className="w-full justify-start text-black-high"
                            onClick={() => {
                              if (item.type_design !== 'normal') {
                                navigate(
                                  ROUTER.DESIGN + '/' + item.type_design
                                );
                              } else {
                                message.info(t('Coming soon!'));
                              }
                            }}
                          />
                        </li>
                      )
                    );
                  })}
              </ul>
            </div>
          }
        >
          <span>
            <ButtonPrimaryLarge
              title={t('Design interior 3D')}
              posIcon={<Icon.ICDesign />}
              type="button"
            />
          </span>
        </Popover>
      </div>
    );
  };

  const value = {
    openLogin,
  };

  return (
    <HeaderContext.Provider value={value}>
      <>
        <header className="flex p-[16px] md:px-[20px] lg:px-[24px] justify-between items-center self-stretch bg-white border-b-[1px] border-solid border-outline-default-divider absolute top-0 left-0 right-0 z-[1000]">
          <div className="flex items-center gap-[6px] lg:h-[40px] overflow-hidden">
            {renderActionHeader(
              'main-action-header',
              'absolute opacity-0 z-[-1000] hidden lg:flex'
            )}
            <div
              className="items-center gap-[6px] absolute transition-all duration-100 ease-linear h-[44px] hidden lg:flex"
              id="promotion-header"
            >
              <span className="text-body-medium">
                <Trans
                  i18nKey="Constant.Free home delivery for orders over {{x}}!"
                  values={{ x: `10,000,000 VNĐ` }}
                  components={{
                    strong: <span className="font-semibold" />,
                  }}
                />
              </span>
            </div>
            <div
              className="flex items-center gap-[8px] lg:hidden"
              onClick={() => openDrawerMenu()}
            >
              <span className="w-[24px] h-[24px] flex items-center">
                <Icon.ICMenu />
              </span>
              <span className="text-title-small">Menu</span>
            </div>
          </div>

          <Link
            to="/"
            className="flex items-center justify-center self-stretch absolute top-[50%] left-[50%] transform translate-x-[-50%] translate-y-[-50%]"
          >
            <img
              src="/assets/logo/new_logo_fitta.png"
              alt=""
              className="h-[24px] lg:h-[40px] object-contain"
            />
          </Link>

          <div className="flex justify-end items-center gap-[4px]">
            {auth.accessToken ? (
              <Badge
                count={cart.data?.cart_items?.filter(item => item)?.length ?? 0}
                size="small"
                className="lg:[&_.ant-scroll-number]:mt-[12px] lg:[&_.ant-scroll-number]:mr-[12px] [&_.ant-scroll-number]:mt-[4px] [&_.ant-scroll-number]:mr-[4px]"
              >
                <ButtonIconGhostLarge
                  icon={<Icon.ICCart />}
                  onClick={() => {
                    openDrawerCart();
                  }}
                  className="lg:flex hidden"
                />
                <ButtonIconGhostSmall
                  icon={<Icon.ICCart />}
                  onClick={() => {
                    openDrawerCart();
                  }}
                  className="lg:hidden"
                />
              </Badge>
            ) : null}

            {/* {auth.accessToken && ( */}
            {auth.accessToken ? (
              <>
                <Popover
                  classNames={{ body: '!p-0' }}
                  getPopupContainer={() => document.body}
                  placement="bottomLeft"
                  trigger={'click'}
                  content={
                    auth.accessToken ? (
                      <div className="flex p-[12px] flex-col items-start gap-[8px] self-stretch w-[324px] bg- rounded-[8px]">
                        <div className="flex py-[16px] px-[24px] flex-col items-center gap-[8px] self-stretch rounded-[8px] bg-primary-primaryFillVarient">
                          <Avatar
                            size={64}
                            src={auth.user?.avatar_url}
                            alt={auth.user?.fullname}
                            icon={<Icon.ICUser />}
                            className="object-cover"
                          />
                          <div className="flex flex-col items-center gap-[4px] self-stretch">
                            <span className="text-title-medium truncate !font-bold text-black-high">
                              {auth.user?.fullname}
                            </span>
                            <span className="text-body-medium truncate">
                              {auth.user?.email}
                            </span>
                          </div>
                        </div>
                        {popoverOptions.map((item, index) => (
                          <ButtonTertiaryLarge
                            key={item.key ?? index}
                            className="self-stretch justify-start gap-8 hover:!bg-fills-primary !text-black-high"
                            title={
                              <span className="text-body-medium">
                                {t(item.label)}
                              </span>
                            }
                            active={window.location.href.includes(item.key)}
                            posIcon={item.icon}
                            onClick={() => {
                              item.onClick?.();
                              // window.location.href = item.key;
                              navigate(item.key);
                            }}
                          />
                        ))}

                        <Divider type="horizontal" className="m-0 !p-0" />
                        <ButtonTertiaryLarge
                          className="self-stretch justify-start gap-8 !text-Accents-Red"
                          title={
                            <span className="text-body-medium">
                              {t('Logout')}
                            </span>
                          }
                          posIcon={<Icon.ICLogOut />}
                          onClick={() => {
                            dispatch(logout()).then(() => {
                              // window.location.replace('/');
                              navigate('/');
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <></>
                    )
                  }
                >
                  <div className="items-center justify-end gap-[4px] cursor-pointer hidden lg:flex">
                    <Avatar
                      size={24}
                      src={auth.user?.avatar_url}
                      alt={auth.user?.fullname}
                      icon={<Icon.ICUser />}
                      className="object-cover"
                    />
                    {/* <span className="text-label-medium">{auth.user?.fullname}</span> */}
                  </div>
                </Popover>
                <ButtonIconGhostSmall
                  icon={<Icon.ICAccount />}
                  onClick={() => {
                    if (!auth.accessToken) {
                      openLogin();
                    } else {
                      // navigate(ROUTER.ACCOUNT);
                      setOpenBottomAccount(true);
                    }
                  }}
                  className="lg:hidden"
                />
              </>
            ) : (
              <>
                <ButtonIconGhostLarge
                  icon={<Icon.ICUser />}
                  onClick={() => {
                    if (!auth.accessToken) {
                      openLogin();
                    }
                  }}
                  className="lg:flex hidden"
                />
                <ButtonIconGhostSmall
                  icon={<Icon.ICAccount />}
                  onClick={() => {
                    openLogin();
                  }}
                  className="lg:hidden"
                />
              </>
            )}

            {/* )} */}
            {device === 'desktop' && (
              <DropdownComponent
                className="justify-between text-black/80"
                trigger={['click']}
                menu={{
                  items: items,
                }}
              >
                <span className="cursor-pointer">
                  {items.find(item => item.key === i18next.language).show}
                </span>
              </DropdownComponent>
            )}
          </div>
        </header>
        <section
          id="sub-header"
          className="lg:flex hidden py-[16px] px-[24px] z-[10] absolute left-0 right-0 top-[73px] justify-between items-center self-stretch bg-fills-white transition-all duration-300 ease-linear"
        >
          {renderActionHeader('', 'w-[500px]')}
          <div className="flex items-center gap-[8px]">
            <ButtonTertiaryLarge
              title={t('Support center')}
              type="button"
              className="text-black/80"
              onClick={() => navigate(ROUTER.CENTER_SUPPORT)}
            />
            <ButtonTertiaryLarge
              title={t('About Fitta')}
              type="button"
              className="text-black/80"
              onClick={() => navigate(ROUTER.ABOUT_US)}
            />
            <Tag
              className="rounded-[8px] bg-[#F7F7F7] h-[32px]"
              label={
                <div className="flex justify-center items-center gap-[6px]">
                  <span className="flex w-[18px] h-[18px] text-primary-primary">
                    <Icon.ICComment />
                  </span>
                  <a
                    href={CONST.laNhaZalo}
                    className="text-body-medium font-semibold"
                  >
                    {t('Book an In-Person Consultation')}
                  </a>
                </div>
              }
            />
          </div>
        </section>
      </>

      {device !== 'desktop' && (
        <BottomAccount
          open={openBottomAccount}
          onClose={() => setOpenBottomAccount(false)}
        />
      )}
    </HeaderContext.Provider>
  );
};

export default Header;

const useDrawerMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { products } = useSelector(state => state.product);
  // const { setOpenModalLogin } = useContext(HeaderContext);
  const { openLogin } = useModalAuth();

  const { user } = useSelector(state => state.auth);
  const auth = useSelector(state => state.auth);
  const { cart } = useSelector(state => state.room);

  const { openDrawerSearch } = useDrawerSearch();
  const { openDrawerCart } = useDrawerCard();

  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const device = useDeviceType();

  const items = [
    {
      key: 'vi',
      show: (
        <div className="flex items-center" style={{ gap: '8px' }}>
          <span className="text-title-small">{t('Vietnamese')}</span>
        </div>
      ),
      label: (
        <div className="flex items-center py-4 px-8" style={{ gap: '8px' }}>
          <img src="/assets/icons/VI.svg" />
          <span className="text-title-small">{t('Vietnamese')}</span>
        </div>
      ),
      onClick: () => {
        i18next.changeLanguage('vi');
      },
    },
    {
      key: 'en',
      show: (
        <div className="flex items-center" style={{ gap: '8px' }}>
          <span className="text-title-small">{t('English')}</span>
        </div>
      ),
      label: (
        <div className="flex items-center py-4 px-8" style={{ gap: '8px' }}>
          <img src="/assets/icons/US.svg" />
          <span className="text-title-small">{t('English')}</span>
        </div>
      ),
      onClick: () => {
        i18next.changeLanguage('en');
      },
    },
  ];
  const openDrawerMenu = () => {
    const drawer = openDrawer({
      title: (
        <span className="lg:text-headline-small text-title-large !font-bold text-center lg:text-left">
          {'Menu'}
        </span>
      ),
      placement: 'left',
      closable: { placement: 'end' },
      classNames: {
        content: 'lg:rounded-tr-[16px]',
        body: '!p-0',
        wrapper: 'shadow-none lg:!w-[400px] !w-full',
      },
      content: (
        <>
          <div className="flex p-[16px] items-center gap-[16px] self-stretch">
            <ButtonSecondaryLarge
              posIcon={<Icon.ICAccount />}
              title={t('Account')}
              onClick={() => {
                if (!auth.accessToken) {
                  openLogin();
                } else {
                  if (device === 'desktop') {
                    // navigate(ROUTER.ACCOUNT + `/${auth?.user?.id}`);
                    window.location.href =
                      ROUTER.ACCOUNT + `/${auth?.user?.id}`;
                  } else {
                    drawer.destroy();
                  }
                }
              }}
              className="grow"
            />
            <ButtonSecondaryLarge
              posIcon={<Icon.ICCart />}
              title={t('Cart')}
              onClick={() => {
                // openDrawerCart();
                window.location.href = ROUTER.CART;
              }}
              preIcon={
                <Badge
                  count={
                    cart.data?.cart_items?.filter(item => item)?.length ?? 0
                  }
                  size="small"
                  offset={[0, 6]}
                />
              }
              className="grow"
            />
          </div>
          <Divider type="horizontal" className="m-0 !p-0" />
          <div className="flex p-[16px] items-center gap-[16px] self-stretch">
            <SearchComponent
              placeholder={t('Nhập nội dung tìm kiếm')}
              style={{ width: '100%' }}
              readOnly={true}
              onClick={() => {
                drawer.destroy();
                openDrawerSearch();
              }}
            />
          </div>
          <div className="flex flex-col lg:h-[calc(100%-150px)] justify-between">
            <ul className="flex flex-col items-start justify-start lg:gap-[2px] gap-[8px] self-stretch grow bg-backgrounds-virtual lg:p-[24px] p-[16px]">
              {products.data
                // ?.filter(item => item.has_design)
                ?.filter(item => item.type_design)
                ?.map((item, index) => {
                  return (
                    <li key={index} className="self-stretch">
                      <ButtonTertiaryLarge
                        title={
                          <span className="text-title-medium">
                            {getValueFromString(item.name)}
                          </span>
                        }
                        className="w-full justify-start text-black/80"
                        onClick={() => {
                          // if (item.type_design !== 'normal') {
                          // navigate(ROUTER.DESIGN + '/' + item.type_design);
                          window.location.href =
                            ROUTER.CATEGORY + '/' + item.id;

                          drawer.destroy();
                          // } else {
                          //   message.info(t('Coming soon!'));
                          // }
                        }}
                      />
                    </li>
                  );
                })}
            </ul>
            <ul className="flex flex-col items-start lg:gap-[2px] gap-[8px] self-stretch lg:p-[24px] p-[16px]">
              <li className="grow self-stretch">
                <ButtonTertiaryLarge
                  title={
                    <span className="text-title-small">
                      {t('Support center')}
                    </span>
                  }
                  posIcon={<Icon.ICHelp />}
                  className="w-full justify-start text-black/80"
                  onClick={() => {
                    // navigate(ROUTER.CENTER_SUPPORT);
                    window.location.href = ROUTER.CENTER_SUPPORT;
                  }}
                />
              </li>
              <li className="grow self-stretch">
                <ButtonTertiaryLarge
                  title={
                    <span className="text-title-small">{t('About us')}</span>
                  }
                  className="w-full justify-start text-black/80"
                  posIcon={<img src="/assets/images/ic_fitta.png" />}
                  onClick={() => {
                    window.location.href = ROUTER.ABOUT_US;
                  }}
                />
              </li>
              <li className="grow self-stretch">
                <ButtonTertiaryLarge
                  title={
                    <span className="text-title-small">{t('Quotation')}</span>
                  }
                  className="w-full justify-start text-black/80"
                  onClick={() => {
                    window.location.href = ROUTER.QUOTATION;
                  }}
                />
              </li>
              <li className="grow self-stretch">
                <DropdownComponent
                  className="justify-between text-black/80"
                  trigger={['click']}
                  menu={{
                    items: items,
                  }}
                  placement="top"
                >
                  <span className="cursor-pointer">
                    <ButtonTertiaryLarge
                      title={
                        <span className="text-title-small">
                          {
                            items.find(item => item.key === i18next.language)
                              .show
                          }
                        </span>
                      }
                      className="w-full justify-start text-black/80"
                      posIcon={<Icon.ICGlobal />}
                      onClick={() => {}}
                    />
                  </span>
                </DropdownComponent>
              </li>
            </ul>
          </div>
        </>
      ),
    });
    return drawer;
  };
  return {
    openDrawerMenu,
  };
};

const useDrawerSearch = () => {
  const { t } = useTranslation();
  // const navigate = useNavigate();

  const openDrawerSearch = () => {
    const drawer = openDrawer({
      title: (
        <span className="text-headline-small !font-bold">{t('Search')}</span>
      ),
      placement: 'left',
      closable: { placement: 'end' },
      classNames: {
        content: 'lg:rounded-tr-[16px]',
        body: '!p-0 bg-backgrounds-virtual',
        wrapper: 'shadow-none lg:!w-[400px] !w-full',
      },
      content: <RenderContentSearch />,
    });
    return drawer;
  };
  return {
    openDrawerSearch,
  };
};

const RenderContentSearch = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const [kwParam, setKwParam] = useState('');
  const timer = useRef(null);
  const [list, setList] = useState([]);

  const reloadData = useCallback(() => {
    dispatch(
      fetchSaleProducts({
        kw: kwParam.trim()?.length ? kwParam.trim() : undefined,
        country_code,
        offset: 0,
        limit: 100,
      })
    ).then(action => {
      if (action.payload?.data) {
        setList(action.payload.data);
      }
    });
  }, [kwParam, country_code]);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      if (kwParam.trim()?.length) {
        reloadData();
      }
    }, 500);

    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [kwParam]);
  return (
    <div className="flex flex-col h-full items-center justify-start">
      <div className="flex self-stretch p-[16px]">
        <SearchComponent
          placeholder={t('Search')}
          style={{ width: '100%' }}
          autoFocus={true}
          setValue={value => {
            setKwParam(value);
          }}
        />
      </div>
      {!list.length && <Empty />}
      <div className="grid grid-cols-1 items-center justify-center overflow-y-auto gap-[16px] p-[16px]">
        {list.map(product => {
          return (
            <ProductCard
              onClick={() => {
                // if (item.type_design === 'sofa') {
                //   window.open(
                //     `https://www.lanhadecor.vn/san-pham/${product.name.toLowerCase()}/${product._id}`,
                //     '_blank'
                //   );
                // } else {
                // window.location.href = ROUTER.PRODUCT_DETAIL + '/' + product.id;
                window.location.href = ROUTER.PRODUCT_DETAIL + '/' + product.id;
                // }
              }}
              className={'w-full max-w-[345px]'}
              item={{
                ...product,
                priceAfter: product.price_after || 0,
                priceOriginal: product.price_original || 0,

                images: [
                  ...(product.image_urls?.map(icon => ({ src: icon })) || []),
                  ...(product.images?.map(icon => ({ src: icon })) || []),
                ],
              }}
              tags={
                product.discount_value
                  ? [
                      {
                        label:
                          product.discount_type === 'PERCENT_DISCOUNT'
                            ? `${product.discount_value}%`
                            : `${convertForeignCurrency(product.discount_value)}`,
                        className:
                          'bg-primary-secondary py-[4px] px-[8px] rounded-[4px]',
                      },
                    ]
                  : null
              }
            />
          );
        })}
      </div>
    </div>
  );
};

const BottomAccount = ({ open, onClose }) => {
  const { slug, id } = useParams();

  const { t } = useTranslation();
  const { user } = useSelector(state => state.auth);
  const auth = useSelector(state => state.auth);
  const { cart } = useSelector(state => state.room);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const listOptions = [
    {
      key: `/${user?.id}`,
      icon: <Icon.ICUser />,
      title: 'Account information',
    },
    {
      key: ROUTER.ORDER,
      icon: <Icon.ICOrder />,
      title: 'My orders',
      onClick: () => {
        dispatch(resetOrdersData());
        dispatch(reloadOrders());
      },
    },
    {
      key: ROUTER.PROJECTS,
      icon: <Icon.ICModule />,
      title: 'Design collection',
    },
    {
      key: ROUTER.ROOMS,
      icon: <Icon.ICBedRoom />,
      title: 'Room collection',
    },
    {
      key: ROUTER.ADDRESS,
      icon: <Icon.ICLocation />,
      title: 'Address',
    },
    {
      key: ROUTER.CHANGE_PASSWORD,
      title: 'Change password',
      icon: <Icon.ICLock />,
    },
  ];
  return (
    <div
      className={cn(
        'flex flex-col items-end justify-end z-[1000] bg-black/25 absolute left-0 top-0 right-0 bottom-0',
        open ? 'opacity-100' : 'opacity-0 delay-300  pointer-events-none'
      )}
    >
      <div
        className={cn(
          'flex items-start flex-col justify-start transition-transform duration-300 ease-in-out self-stretch',
          open ? 'translate-y-0' : 'translate-y-full'
        )}
      >
        <div className="flex bg-white md:px-[20px] p-[16px] lg:hidden justify-between items-center self-stretch border-b-[1px] border-solid border-b-outline-default-divider rounded-t-[16px]">
          <span className="text-title-large !font-bold">{t('Account')}</span>
          <ButtonIconOutlineMedium icon={<Icon.ICClose />} onClick={onClose} />
        </div>
        <div className="flex md:px-[20px] p-[16px] items-start gap-[40px] self-stretch bg-white overflow-y-auto ">
          <div className="flex flex-col items-center gap-[16px] self-stretch grow">
            <div className="flex px-[24px] py-[16px] flex-col items-center gap-[8px] self-stretch rounded-[16px] bg-primary-primaryFillVarient">
              <Avatar size={64} src={user?.avatar_url} icon={<Icon.ICUser />} />
              <span className="text-title-medium !font-bold ellipsis-multiline-1">
                {user?.fullname}
              </span>
              <span className="text-body-medium">{user?.email}</span>
            </div>
            <Divider type="horizontal" className="m-0 p0 hidden lg:block" />
            {listOptions.map((item, index) => (
              <ButtonTertiaryLarge
                key={item.key ?? index}
                className="self-stretch justify-start gap-8 hover:!bg-fills-primary !text-black-high"
                title={
                  <span className="text-body-medium">{t(item.title)}</span>
                }
                active={item.key.includes(slug) || slug === `/${user?.id}`}
                posIcon={item.icon}
                onClick={() => {
                  if (item.onClick) item.onClick();
                  // window.location.href = ROUTER.ACCOUNT + item.key;
                  navigate(ROUTER.ACCOUNT + item.key);
                }}
              />
            ))}
            <Divider type="horizontal" className="m-0 !p-0" />
            <ButtonTertiaryLarge
              className="self-stretch justify-start gap-8 !text-Accents-Red"
              title={<span className="text-body-medium">{t('Logout')}</span>}
              posIcon={<Icon.ICLogOut />}
              onClick={() => {
                dispatch(logout()).then(() => {
                  // window.location.replace('/');
                  navigate('/');
                  onClose();
                });
              }}
            />
            <Divider type="horizontal" className="m-0 p0" />
            <ButtonTertiaryLarge
              className="self-stretch justify-start gap-8 !text-Accents-Red"
              title={
                <span className="text-body-medium">{t('Delete account')}</span>
              }
              posIcon={<Icon.ICDelete />}
              onClick={async () => {
                const modal = openModal({
                  title: (
                    <div className="flex self-stretch items-center justify-center">
                      <img src="/assets/icons/icon-delete-account.svg" />
                    </div>
                  ),
                  content: (
                    <>
                      <span className="text-headline-small text-center">
                        {t('Delete account')}
                      </span>
                      <span className="text-body-medium text-center">
                        {t(
                          "We're sorry to see you go. We will send you an email to confirm the account deletion. Please check your email."
                        )}
                      </span>
                    </>
                  ),
                  centered: true,
                  width: 538,
                  classNames: {
                    header: '!px-[24px] !pt-[32px] !pb-[16px] !m-0',
                    footer: '!p-[24px] gap-[16px] items-end flex justify-end',
                    body: '!px-[24px] !py-[16px] flex flex-col items-center gap-[16px]',
                  },
                  footer: (
                    <>
                      <ButtonSecondaryLarge
                        title={t('Xóa tài khoản')}
                        onClick={() => {
                          modal.destroy();
                          dispatch(
                            requestDeleteAccount({
                              redirect_url:
                                window.location.origin + ROUTER.HOMEPAGE,
                            })
                          );
                          onClose();
                        }}
                        className={'self-stretch grow text-Accents-Red'}
                      />
                      <ButtonPrimaryLarge
                        title={t('Giữ tài khoản')}
                        onClick={() => modal.destroy()}
                        className={'self-stretch grow'}
                      />
                    </>
                  ),
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
